<div class="card">
    <div class="body">
        <p class="lead">{{title}}</p>
        <p>{{sub_title}}</p>
        <div class="form-auth-small m-t-20" [formGroup]="dataForm">
            <div class="form-group" *ngIf="mode=='CHANGE'">
                <input type="password" formControlName="old_password" class="form-control round"
                    placeholder="Old Password">
                <span class="error" *ngIf="dataForm?.get('old_password')?.errors?.required">Old Password should not Empty</span>
            </div>
            <div class="form-group">
                <input type="password" formControlName="password" class="form-control round" placeholder="Password">
                <span class="error" *ngIf="dataForm?.get('password')?.errors?.matching">Password Should be match</span>
                <span class="error" *ngIf="dataForm?.get('password')?.errors?.required">Password should not empty</span>
            </div>
            <div class="form-group">
                <input type="password" formControlName="confirm_password" class="form-control round" placeholder="Password">
                <span class="error" *ngIf="dataForm?.get('confirm_password')?.errors?.matching">Password Should be match</span>
                <span class="error" *ngIf="dataForm?.get('confirm_password')?.errors?.required">Password should not empty</span>
            </div>
            <span *ngIf="error_info" class="error">{{error_info}}</span>
            <button type="submit" noDoubleClick (click)="changePassword()" [disabled]="loading"
                class="btn btn-primary btn-round btn-block">
                <i *ngIf="loading" class="pi pi-spin pi-spinner"></i>
                {{ loading ? 'Saving...' : 'Change Password'}}
            </button>
        </div>
        <!-- <div class="separator-linethrough"><span>OR</span></div> -->
    </div>
</div>